/* global Office */

/**
 * Open a URL in the user's default system browser.
 *
 * From inside the Excel task pane, `window.open` doesn't reach the real
 * browser — Office intercepts it and pops a small in-frame webview, which
 * is a jarring UX and often breaks auth flows that expect real browser
 * cookies. `Office.context.ui.openBrowserWindow` is the sanctioned API for
 * "hand this URL to the user's default browser and let them handle it."
 *
 * Falls back to `window.open` when the Office API isn't available — i.e.
 * standalone mode, where we're already IN a browser and a new-tab open is
 * exactly what we want.
 */
export function openExternalUrl(url: string): void {
  if (typeof Office !== "undefined" && Office?.context?.ui?.openBrowserWindow) {
    Office.context.ui.openBrowserWindow(url);
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
